
    import Component from "vue-class-component";
    import Vue from "vue";
    import {Prop} from "vue-property-decorator";
    import {BvTableFieldArray} from "bootstrap-vue"
    import {ApplicationActions, SeafaringProperties } from "@/api-client";
    import TableItem from "@/features/applications/components/TableItem";
    import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
    import Loader from "@/features/shared/components/Loader";
    import PopoverInfo from "@/components/PopoverInfo.vue";
    import {PopoverProps} from "@/features/applications/components/PopoverProps";

    // eslint-disable-next-line @typescript-eslint/interface-name-prefix
    export interface ITableItem {
        id: string;
    }

    @Component({
        components: {
            TableEmptySlot,
            PopoverInfo
        }
    })
    export default class RequirementsTable extends Vue {
        @Prop({required: true})
        actions!: ApplicationActions;

        @Prop({required: true})
        fields!: BvTableFieldArray;

        @Prop({required: true, default: () => []})
        chosenItems! : TableItem[];

        @Prop({required: true})
        chosenItemHeading! : string;

        @Prop({required: true, default: () => []})
        choosableItems! : TableItem[];

        @Prop({required: true})
        choosableItemsHeading! : string;

        @Prop({required: true})
        chooseItem!: Function;

        @Prop()
        addNewItemButtonText! : string;

        @Prop({default: false})
        showNewItemButton! : boolean;

        @Prop({required: true})
        chosenLoader! : Loader;

        @Prop({required: true})
        choosableLoader! : Loader;

        @Prop()
        popoverInfo? : PopoverProps;

        detailTypes = {
            seafaringProperties: SeafaringProperties,
        };

        get chosenItemTable() : TableItem[] {
            this.chosenItems.forEach(item =>
                (item as any)._showDetails = (item as any)._details != null
            );
            return this.chosenItems;
        }

        get choosableItemTable() : TableItem[] {
            this.choosableItems.forEach(item =>
                (item as any)._showDetails = (item as any)._details != null
            );
            // Filters out elements from 'choosable' table if they are already present in 'chosen' table
            return this.choosableItems.filter(x => {
              let showItem = true;
              function shouldItemBeHidden(item: TableItem) {
                if (item.id == x.id) showItem = false;
              }
              this.chosenItems.forEach(shouldItemBeHidden);

              return showItem;
            })
        }

        onItemClicked(item: TableItem){
            this.$emit('table-item-clicked', item);
        }

        onItemRemove(item: TableItem){
            this.$emit('chosen-item-removed', item.id);
        }

        getPopoverKey() {
          return `head(${this.popoverInfo?.labelKey})`;
        }

        created(){
            const addedItemId = this.$route.params.addedItemId;
            if(addedItemId){
                delete this.$route.params.addedItemId;
                this.chooseItem({id: addedItemId} as TableItem);
            }
        }
    }
